import { fill } from "lodash/fill";
import React, { useContext, useState } from "react";
import { toast } from "react-toastify";
import { Button, Card, CardBody, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import AppContext from "../../../context/Context";
import apiCall from "../../../services/apiCall";
import parse from "html-react-parser";

const ApiConsentfromAdminToPartner = ({ applicationDetails, GetApiData, setIsRefreshData, IsRefreshData }) => {
  const [body, setBody] = useState({});

  const { accessToken, loginUserDetails } = useContext(AppContext);

  const newArrayForCheck = [...GetApiData];
  const [AllChecked, setAllChecked] = useState(newArrayForCheck.fill(false));

  const PostSignedApi = () => {
    apiCall
      .servertrip("POST", "signed_api_consent_for_application", loginUserDetails, undefined, body)
      .then((res) => {
        toast.success(`${res.data.message}`);
        setIsRefreshData(!IsRefreshData);
      })
      .catch((error) => {
        const resMessage =
          (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        toast.error(resMessage);
        setIsRefreshData(!IsRefreshData);
      });
  };

  return (
    <>
      <Card className="mb-3  overflow-visible">
        {/* <SikkaCardHeader title="Api Consent from Admin To Partner" /> */}
        <CardBody className="ml-3 mr-3 mb-1 mt-1 ">
          {GetApiData.map((data, index) => {
            if (data.app_id === applicationDetails.app_id) {
              return (
                <>
                  <Form key={index}>
                    <Row>
                      <Col>
                        <FormGroup>
                          <Input
                            value={AllChecked[index]}
                            type="checkbox"
                            onChange={() => {
                              let myBody = {
                                app_id: `${data.app_id}`,
                                api_name: `${data.api_name}`,
                                cas_id: `${data.cas_id}`,

                                signed_by: `${loginUserDetails.user_name}`,
                              };
                              setBody(myBody);
                            }}
                            onClick={() => {
                              let itemIndex = index;
                              let newItem = !AllChecked[itemIndex];

                              let newList = AllChecked.map((item, index) => {
                                return index === itemIndex ? newItem : item;
                              });

                              setAllChecked(newList);
                            }}
                          />
                          <Label className="ml-1 text-capitalize">{parse(data.api_consent_text)}</Label>
                        </FormGroup>
                      </Col>

                      <Col className="text-center">
                        <Button
                          className="mr-1 mt-1"
                          size="sm"
                          color="primary"
                          type="submit"
                          onClick={(e) => {
                            e.preventDefault();
                            setBody(Object.assign(body, { status: "signed" }));

                            if (AllChecked[index] === true) {
                              PostSignedApi();
                            }
                          }}
                          disabled={!AllChecked[index]}
                        >
                          I Agree
                        </Button>
                        <Button
                          className="mt-1"
                          size="sm"
                          color="danger"
                          type="submit"
                          onClick={(e) => {
                            e.preventDefault();

                            setBody(Object.assign(body, { status: "disagree" }));

                            if (AllChecked[index] === true) {
                              PostSignedApi();
                            }
                          }}
                          disabled={!AllChecked[index]}
                        >
                          I Disagree
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                  <hr />
                </>
              );
            }
          })}
        </CardBody>
      </Card>
    </>
  );
};

export default ApiConsentfromAdminToPartner;
